<div
  class="tournament-controls"
  fxLayout="row wrap"
  fxLayoutAlign="start center"
  fxLayoutGap="16px"
  fxLayoutGap.gt-1440="28px"
  [ngClass]="{
    'life-experience': isLifeExperience,
    'cash-page': !isLifeExperience && isEventPage
  }"
>
  <!-- join -->
  @if (showJoinButton) {
    <button
      mat-flat-button
      class="fz-button--small animation__glow"
      color="primary"
      [attr.data-ga-value]="analyticKeyPrefix() + 'join-button'"
      (click)="onJoin()"
    >
      <div>Join</div>
    </button>
  }

  <!-- play -->
  <div
    [matTooltip]="
      !isCompleted && isFinished
        ? 'The tournament is not completed yet but it\'s expired since ' +
          (endTime | fzDateFormat | async)
        : isCompleted
          ? 'The tournament is completed.'
          : maximumEntriesReached
            ? maximumEntriesReachedTooltip
            : 'Click to play the tournament'
    "
    matTooltipClass="info-tooltip"
    aria-label="A button that plays the tournament"
    *ngIf="showPlayButton && !isComingSoon"
  >
    <button
      mat-flat-button
      color="primary"
      (click)="onPlay()"
      [attr.data-ga-value]="analyticKeyPrefix() + 'play-button'"
      [disabled]="isDisabled"
      [ngClass]="{
        'mat-button-loading': playButtonLoading === false,
        animation__glow: !isDisabled
      }"
      [fzProcessing]="
        playButtonProcessing || playButtonLoading === false || false
      "
      [fzProcessingHideContent]="true"
      class="play-button fz-button--small"
    >
      <mat-icon *ngIf="activePass && !isDisabled">
        confirmation_number
      </mat-icon>
      {{ playButtonText }}
    </button>
  </div>

  <fz-subscribe-button
    *ngIf="showPlayButton && isComingSoon"
    [currentUser]="user"
    [eventSchedule]="eventScheduler"
    [eventPrototypeUuid]="
      tournament ? tournament.uuid : tournamentDetails?.eventPrototypeUuid
    "
    [responsive]="responsive"
  ></fz-subscribe-button>

  <!-- Play another -->
  @if (showPlayButtonAnother) {
    <button
      mat-flat-button
      (click)="onPlayAnother()"
      class="play-another-tournament-button fz-button--small animation__glow"
      [attr.data-ga-value]="
        analyticKeyPrefix() + 'tournament-control-play-another'
      "
      [ngClass]="{ 'game-over-cash': isGameOverPage && !isLifeExperience }"
    >
      Play another tournament
    </button>
  }

  <!-- try for free -->
  @if (showTryForFreeButton || !isLifeExperience) {
    <button
      mat-stroked-button
      class="fz-button--small try-free desktop"
      (click)="onTryForFree()"
      [attr.data-ga-value]="analyticKeyPrefix() + 'tournament-control-try-free'"
    >
      Try For Free
    </button>
  }

  <!-- share -->
  @if (showShareButton) {
    <button
      class="share-button fz-button--small"
      matTooltip="Share tournament"
      mat-stroked-button
      (click)="onShare()"
      [attr.data-ga-value]="analyticKeyPrefix() + 'tournament-control-share'"
      data-testid="banner_share_button"
    >
      <mat-icon
        [attr.data-ga-value]="analyticKeyPrefix() + 'tournament-control-share'"
        >share</mat-icon
      >
      Share
    </button>
  }

  <button
    *ngIf="user?.membershipInfo?.type === 'MEMBER' && showBecomeZboButton"
    mat-stroked-button
    class="become-zbo-button fz-button--small animation__glow"
    [attr.data-ga-value]="analyticKeyPrefix() + 'tournament-control-become-zbo'"
    (click)="becomeZBO()"
  >
    Become ZBO
  </button>
  <button
    *ngIf="showMoreOptions"
    class="more-button fz-button--small"
    [class.show-more]="vipVideo"
    [matMenuTriggerFor]="menu"
    mat-icon-button
  >
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu" id="controls_menu" backdropClass="user-menu">
    <button
      mat-menu-item
      *ngIf="vipVideo"
      (click)="onWatchPromotionalVideo()"
      [attr.data-ga-value]="analyticKeyPrefix() + 'play-watch-video'"
    >
      <mat-icon>slideshow</mat-icon>
      Watch Promotional Video
    </button>
    <mat-divider *ngIf="vipVideo"></mat-divider>

    <button mat-menu-item *ngIf="isCompleted || isFinished" (click)="onShare()">
      <mat-icon>share</mat-icon>
      Share
    </button>
    <button
      mat-menu-item
      (click)="onTryForFree()"
      [attr.data-ga-value]="analyticKeyPrefix() + 'try-for-free'"
    >
      <mat-icon>sports_esports</mat-icon>
      Try For Free
    </button>
  </mat-menu>
</div>
